import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-asset",
  "use": "icon-asset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-asset\"><path d=\"M576 512c0 47.1 38.2 85.3 85.3 85.3s85.3-38.2 85.3-85.3c0-47.1-38.2-85.3-85.3-85.3S576 464.9 576 512z m128 0c0 23.6-19.1 42.7-42.7 42.7s-42.7-19.1-42.7-42.7 19.1-42.7 42.7-42.7S704 488.4 704 512z m256-170.7v-192c0-23.6-19.1-42.7-42.7-42.7H106.7c-23.6 0-42.7 19.1-42.7 42.7v725.3c0 23.6 19.1 42.7 42.7 42.7h810.7c23.6 0 42.7-19.1 42.7-42.7V512c0-11.8-9.6-21.3-21.3-21.3-11.8 0-21.3 9.6-21.3 21.3v149.3H490.7V362.7h448c11.7 0 21.3-9.6 21.3-21.4zM917.3 320h-448c-11.8 0-21.3 9.6-21.3 21.3v341.3c0 11.8 9.6 21.3 21.3 21.3h448v149.3c0 11.8-9.6 21.3-21.3 21.3H128c-11.8 0-21.3-9.6-21.3-21.3V170.7c0-11.8 9.6-21.3 21.3-21.3h768c11.8 0 21.3 9.6 21.3 21.3V320z\" fill=\"#000000\" p-id=\"6744\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/asset.svg
// module id = S8k9
// module chunks = 77